var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMirIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 12,
    viewBox: "0 0 45 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2350_30500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7321 2.2831e-07V0.0052404C12.7267 0.0052404 11.0246 1.99897e-07 10.5707 1.57729C10.1547 3.02358 8.98211 7.01659 8.94969 7.12664H8.62548C8.62548 7.12664 7.4259 3.04454 7.00443 1.57205C6.55054 -0.00523999 4.84303 2.2831e-07 4.84303 2.2831e-07H0.952515V12H4.84303V4.87336H5.00514H5.16724L7.43671 12H10.1385L12.4079 4.8786H12.7321V12H16.6227V2.2831e-07H12.7321Z",
    fill: "#A6A391"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9432 0C26.9432 0 25.8031 0.0995633 25.2681 1.25764L22.5123 7.12664H22.1881V0H18.2976V12H21.972C21.972 12 23.1662 11.8952 23.7011 10.7424L26.4029 4.87336H26.7271V12H30.6176V0H26.9432Z",
    fill: "#A6A391"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3467 5.44922V11.9994H36.2372V8.17411H40.4519C42.2891 8.17411 43.8453 7.03699 44.4235 5.44922H32.3467Z",
    fill: "#A6A391"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.452 0H31.801C32.2333 2.28472 34.0002 4.11878 36.2859 4.71616C36.8047 4.8524 37.3504 4.92576 37.9124 4.92576H44.5803C44.6397 4.65328 44.6667 4.37555 44.6667 4.08734C44.6667 1.82882 42.7809 0 40.452 0Z",
    fill: "#A6A391"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2350_30500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7143,
    height: 12,
    fill: "white",
    transform: "translate(0.952515)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirIcon);
export default __webpack_public_path__ + "static/media/MirIcon.f3a225c2f83b020dc9f4e5f6226b2019.svg";
export { ForwardRef as ReactComponent };